import type { UserManagerSettings } from "oidc-client-ts";
import type { AuthConfig } from "./types";

/**
 * Create OIDC UserManager configuration from AuthConfig.
 */
export function createOidcConfig(config: AuthConfig): UserManagerSettings {
  return {
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: config.redirectUri,
    post_logout_redirect_uri:
      config.postLogoutRedirectUri ?? config.redirectUri.replace("/callback", ""),
    silent_redirect_uri:
      config.silentRedirectUri ??
      config.redirectUri.replace("/callback", "/silent-renew"),
    scope: config.scope ?? "openid profile email offline_access cheatsheetz-api",
    response_type: "code",
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: true,
    loadUserInfo: true,
  };
}
